import React from 'react';
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../components/DivContainerBody";
import {EditIcon} from "../../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import UpdateContractApp from "../../Functionality/ContractCreateUpdateFlows/UpdateContractApp";
import CommonContractApp from "../../Functionality/ContractCreateUpdateFlows/CommonContractApp";
import ContractFields from "../../SubComponents/ContractCreateUpdateFlows/ContractFields";
import {permissionObj} from "../../../../../Helpers/permission";

const UpdateContract = () => {
    const props  = CommonContractApp();
    const {
        t,
        dispatch,
        navigate,
        DEV,
        permission,
        contract,
        setContract,
        emptyFields,
        setEmptyFields,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        getAllContractor,
        modified,
        setModified,
        contractId,
        handleStartDateChange,
        handleEndDateChange,
    } = props;

    const { handleSubmit} = UpdateContractApp({
        t,
        dispatch,
        navigate,
        contractId,
        contract,
        setContract,
        isValidStartDate,
        isValidEndDate,
        setEmptyFields,
        modified,
        setModified
    });

    if(!DEV && (!permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_READ) || !permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_UPDATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={ t('update')} link={routes.contractor.list} >
                <ButtonAction
                    id='btn_cc_update'
                    name={'update'}
                    Icon={EditIcon}
                    className={'btn-icon-edit'}
                    onClick={handleSubmit}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className={"row mt-5"}>
                    <ContractFields
                        contract={contract}
                        setContract={setContract}
                        emptyFields={emptyFields}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        getAllContractor={getAllContractor}
                        handleStartDateChange={handleStartDateChange}
                        handleEndDateChange={handleEndDateChange}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};

export default UpdateContract;
